// Write your code here
import './index.css'
import {Component} from 'react'
import DestinationItem from '../DestinationItem'

class DestinationSearch extends Component {
  state = {searchInput: ''}

  onChangeSearchInput = e => {
    console.log(e.target.value)
    this.setState({searchInput: e.target.value})
  }

  render() {
    const {destinationsList} = this.props
    const {searchInput} = this.state

    const searchResult = destinationsList.filter(each =>
      each.name.toLowerCase().includes(searchInput),
    )
    return (
      <div className="bg-container">
        <div className="container">
          <div className="headingAndInput">
            <h1 className="heading">Destination Search</h1>
            <div className="input-search">
              <input
                className="input"
                placeholder="Search"
                type="Search"
                onChange={this.onChangeSearchInput}
              />
              <img
                src="https://assets.ccbp.in/frontend/react-js/destinations-search-icon-img.png"
                className="search"
                alt="search icon"
              />
            </div>
          </div>
          <ul className="cards-container">
            {searchResult.map(each => (
              <DestinationItem destination={each} key={each.id} />
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

export default DestinationSearch
